import { render, staticRenderFns } from "./SankeyLoader.vue?vue&type=template&id=fe78cfb8&"
import script from "./SankeyLoader.vue?vue&type=script&lang=js&"
export * from "./SankeyLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports